import { render, staticRenderFns } from "./FinSortDetail.vue?vue&type=template&id=415d425d&scoped=true&"
import script from "./FinSortDetail.vue?vue&type=script&lang=js&"
export * from "./FinSortDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415d425d",
  null
  
)

export default component.exports